/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-28 10:10:30 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 13:49:05
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" lastTitle="Publisher FAQ"/>
    <div class="docs">
      <h1>Payments and Support</h1>
      <h2>When and how do I get paid as an Artemis Ads Affiliate?</h2>
      <p>
        Affiliates are paid monthly, at the end of each month, for the
        commissions earned in the month before last.
      </p>
      <ul>
        <li>
          Example: Commissions earned from March 1st to March 31st will be paid
          on May 31th.
        </li>
        <li>Payments are made via Bank transfer or Paypal</li>
      </ul>
      <p>
        If you have any questions or concerns about payments, you can contact
        the Artemis Ads support team.
      </p>
      <h2>Is there support available for Artemis Ads affiliates?</h2>
      <p>
        Yes, Artemis Ads provides dedicated support for affiliates, including:
      </p>
      <ul>
        <li>A knowledge base with guides and FAQs</li>
        <li>Email support for direct assistance</li>
      </ul>
      <p>
        Affiliates can reach out whenever they need help with their account,
        promotions, or payments.
      </p>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
</script>